// Consentimento LGPD da primeira visita (LgpdConsentModal grava; avisos de primeira visita leem para não abrir
// por cima do modal de consentimento).
export const LGPD_CONSENT_STORAGE_KEY = 'agendario_lgpd_consent';

export function hasLgpdConsent(storage = (typeof window !== 'undefined' ? window.localStorage : null)) {
  try { return storage?.getItem(LGPD_CONSENT_STORAGE_KEY) != null; } catch { return false; }
}
